import { computed } from 'mobx';
import { BaseAuth } from '@link/share/stores';

export class Auth extends BaseAuth {
  @computed
  get email(): string {
    return this.user?.email || '';
  }
  @computed
  get isUnauthorizedUser(): boolean {
    return !this.claims?.ADMIN_SERVICE;
  }
}

export default new Auth();
